import CidadeFormView from './Cidade.FormView'
import RenegociacaoFormView from './Renegociacao.FormView'

export default {
  CidadeFormView,
  RenegociacaoFormView
}
